function attributeTitleAllAnchors() {
  Array.from(document
    .querySelectorAll('body .elementor-inner a:not([title])'))
    .forEach(a => a.title = `Ir para ${a.innerText || a.href.split(/\/+/).at(0)}`);
}

function attributeTitleAllImages() {
  Array.from(document
    // .querySelectorAll('body .elementor-inner img:not([title])'))
    .querySelectorAll('img:not([title])'))
    .forEach(img => img.title = img.alt || img.src.split(/\/+/).at(-1));
}

window.addEventListener("load", () => {
  attributeTitleAllAnchors();
  attributeTitleAllImages();
});

